module.exports = __webpack_public_path__ + "f73f7dcf3994751688c2a4ae0570583a.png";